namespace SorAraBul.Administration {
    export interface CompaniesForm {
        Name: Serenity.StringEditor;
        TaxOffice: Serenity.StringEditor;
        TaxNumber: Serenity.StringEditor;
        AddressDetail: Serenity.StringEditor;
        CityId: Serenity.ServiceLookupEditor;
        IlceId: Serenity.ServiceLookupEditor;
        ContactNumber: Common.PhoneEditor;
        PostalCode: Serenity.StringEditor;
    }

    export class CompaniesForm extends Serenity.PrefixedContext {
        static formKey = 'Administration.Companies';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!CompaniesForm.init)  {
                CompaniesForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.ServiceLookupEditor;
                var w2 = Common.PhoneEditor;

                Q.initFormType(CompaniesForm, [
                    'Name', w0,
                    'TaxOffice', w0,
                    'TaxNumber', w0,
                    'AddressDetail', w0,
                    'CityId', w1,
                    'IlceId', w1,
                    'ContactNumber', w2,
                    'PostalCode', w0
                ]);
            }
        }
    }
}
